import { render, staticRenderFns } from "./SearchProductoComponent.vue?vue&type=template&id=3b5accf8&scoped=true&"
import script from "./SearchProductoComponent.vue?vue&type=script&lang=js&"
export * from "./SearchProductoComponent.vue?vue&type=script&lang=js&"
import style0 from "./SearchProductoComponent.vue?vue&type=style&index=0&id=3b5accf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5accf8",
  null
  
)

export default component.exports